export const isSecondRead = window.config.system_mode === "secondread";